import { render } from "./ServerInfo.vue?vue&type=template&id=5e5d9d95&scoped=true&ts=true"
import script from "./ServerInfo.vue?vue&type=script&lang=ts"
export * from "./ServerInfo.vue?vue&type=script&lang=ts"

import "./ServerInfo.vue?vue&type=style&index=0&id=5e5d9d95&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e5d9d95"]])

export default __exports__
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QCard,QCardSection});
